export default __webpack_public_path__ + "static/media/ai.807dc49a.jpeg";